// extracted by mini-css-extract-plugin
export default {"routineblock":"OW","container":"PW","carousel":"QW","routine":"RW","heading":"SW","routinelist":"TW","routineitem":"UW","routineimg":"VW","routinedesc":"WW","routinename":"XW","routinetext":"YW","carouselwrap":"ZW"};
    if(module.hot) {
      // 1737143663829
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  